import { useTranslation, useUserInfo, useUserPlanName } from "@next-platform/client-common-core";
import { Button, Modal } from "@next-platform/client-common-spicy-ui";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import Trans from "@/components/Trans/Trans";
import { PERSONA_LIMIT, ROUTES, USER_ROLES } from "@/constants";
import { getPersonaLimit } from "@/utils";
import { getIsPartner } from "@/utils/getIsPartner";

import { LimitReachModalProps } from "./types";

const tierTransComponents = { 1: <strong /> };

export default function LimitReachedModal(props: LimitReachModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isOpen, onClose } = props;
  const { role } = useUserInfo();
  const isPartner = getIsPartner();
  const limit = isPartner ? PERSONA_LIMIT.PAID_PREMIUM : getPersonaLimit(role);
  const planName = useUserPlanName(role);
  const isHighestTier = role === USER_ROLES.PREMIUM || isPartner;
  const baseValues = useMemo(() => ({ limit }), [limit]);
  const planTransValues = useMemo(() => ({ tier: planName }), [planName]);

  const handleUpgradeClick = useCallback(() => {
    navigate(ROUTES.subscribe);
  }, [navigate]);

  return (
    <Modal
      title={t("personas:modal.limitReached.title")}
      description={
        <>
          <Trans i18nKey="personas:modal.limitReached.description.base" values={baseValues} />
          {!isPartner && <Trans i18nKey="personas:modal.limitReached.description.tierSuffix" values={planTransValues} components={tierTransComponents} />}
          . <Trans i18nKey="personas:modal.limitReached.description.instruction" />
          {!isHighestTier && <Trans i18nKey="personas:modal.limitReached.description.upgradeSuffix" />}.
        </>
      }
      open={isOpen}
      onOpenChange={onClose}
      dismissable={true}
      actions={
        !isHighestTier ? (
          <Button onClick={handleUpgradeClick}>
            <Trans i18nKey="personas:modal.limitReached.cta.label" />
          </Button>
        ) : null
      }
      backdrop="blur"
    ></Modal>
  );
}
